



















































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Emit, Watch } from "vue-property-decorator";
import UserInterface from "@/types/app/IUser";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import Header from "@/types/app/header";
import formatDate, {
  formatDateWithTime,
  dateDiff,
  setDaysInDate,
} from "@/utils/formatDate";
import { truncate } from "@/utils/truncate";
import AuditLogService from "@/services/auditService";
import AuditLogAuth from "@/components/headers/audit-logs-auth";
import { AuditTypes } from "@/types/app/auditLogs";
import BaseComponent from "@/utils/baseComponent";
import AuditLogCrud from "@/components/headers/audit-logs-crud";
import AuditLogEmail from "@/components/headers/audit-logs-email";
import AuditLogLogger from "@/components/headers/audit-logs-logger";
import AuditLogViewProduct from "@/components/headers/audit-logs-viewproducts";
import Customer from "@/types/customer/Customer";
import { xhrCallback } from "@sentry/tracing/types/browser/request";
import WalletService from "@/services/walletService";
import RefreshStore from "@/services/refreshStore";
import Endpoint from "@/utils/endpoint";
import compareTo from "@/utils/compareTo";
import applyCondition from "@/utils/applyCondition";

interface ProductSelectValue {
  id: string;
  title: string;
  is506c?: boolean;
}

@Component({
  methods: {
    formatDateWithTime,
    truncate,
  },
})
export default class AuditLogs extends BaseComponent {
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;
  @Getter("getCustomersAll", { namespace: "customer" }) customersAll!: Customer[];
  private auditService = new AuditLogService(this.$http);
  walletService = new WalletService(this.$http);
  formatDateWithTime = formatDateWithTime;
  formatDate = formatDate;
  loadingAuthLogs = false;
  headers: Header[] = AuditLogAuth.header;
  items: any[] = [];

  auditType: AuditTypes = AuditTypes.Auth;
  private endpoint = new Endpoint();
  products: VuetifySelectItems[] = [];
  itemsAuditType = ["Auth"];
  itemsApis = ["Auth", "Product", "Customer", "Investment"];
  apiSelect = "Auth";
  fromDateMenu = false;
  permissionFilterDays = 45;
  fromDate = this.dateNowFormat(this.DateTimeNow);
  toDateMenu = false;
  toDate = this.dateNowFormat(new Date());
  whoFilter = "";

  async mounted() {
    const [productResponse] = await Promise.all([this.walletService.getProducts()]);
    this.products = productResponse;
    if (this.items.length == 0) this.handleLogAuths();
  }

  get filteredLogs() {
    const conditions: any[] = [];
    if (this.whoFilter) {
      conditions.push((item: any) =>
        item.who.toLowerCase().includes(this.whoFilter.toLowerCase())
      );
    }
    return applyCondition<any>(this.items, conditions);
  }

  get DateTimeNow(): Date {
    return setDaysInDate(new Date().toString(), -this.permissionFilterDays);
  }

  dateNowFormat(date: Date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  async handleLogAuths() {
    console.log("handleLogAuths", this.fromDate, this.toDate);
    this.loadingAuthLogs = true;
    this.items = [];
    try {
      const diffDays = dateDiff(this.fromDate, this.toDate);
      console.log("dateDiff", diffDays);
      if (diffDays > this.permissionFilterDays) {
        this.showError(
          `Number of days in the filter cannot be great than ${this.permissionFilterDays}`
        );
        return;
      }

      const newCompanies = await this.auditService.getLogAuths(
        this.apiSelect,
        this.auditType,
        this.fromDate,
        this.toDate
      );
      switch (this.auditType) {
        case AuditTypes.Auth:
          this.headers = AuditLogAuth.header;
          break;
        case AuditTypes.Clone:
          this.headers = AuditLogAuth.header;
          break;
        case AuditTypes.Crud:
          this.headers = AuditLogCrud.header;
          break;
        case AuditTypes.Email:
          this.headers = AuditLogEmail.header;
          break;
        case AuditTypes.Logger:
          this.headers = AuditLogLogger.header;
          break;
        case AuditTypes.ViewProduct:
          this.headers = AuditLogViewProduct.header;
          break;
        default:
          break;
      }
      this.items = newCompanies.filter(
        (x) =>
          x.what != "Auth" ||
          (x.who != "admin" &&
            !x.who.includes("admin => emulate") &&
            !x.who.includes("developer@usabit.com.br => emulate"))
      );
    } finally {
      this.loadingAuthLogs = false;
    }
  }

  @Watch("apiSelect")
  async handleApiSelect() {
    switch (this.apiSelect) {
      case "Auth":
        this.itemsAuditType = ["Auth"];
        break;
      case "Customer":
        this.itemsAuditType = ["Email", "Crud"];
        break;
      case "Product":
        this.itemsAuditType = ["ViewProduct", "Crud"];
        break;
      case "Investment":
        this.itemsAuditType = ["Clone", "Crud"];
        break;
    }
  }

  async exportCsv() {
    const newList = this.items.map((x) => {
      x.localDate = this.formatDateWithTime(x.when);
      if (this.auditType == AuditTypes.ViewProduct) {
        x.who = this.getUserName(x.userId);
        x.data = this.getName(x.data);
      }
      return x;
    });

    this.exportCSVFile([...newList], `${AuditTypes.Auth.toString()}-export`);
  }

  getName(productId: string) {
    return (
      this.products?.find((p: VuetifySelectItems) => p.value == productId)?.text ??
      "Not found"
    );
  }

  getUserName(id: string) {
    return this.customersAll?.find((u: Customer) => u.id == id)?.email ?? "Not found";
  }

  async getProducts(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productsOnlyPublished;
    const response = await this.$http.get(`${url}&pastOnly=false`);
    const productFunds = response.data as ProductSelectValue[];
    const productFundsOrdened = productFunds.sort((a, b) => compareTo(a.title, b.title));

    const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
      text: productFund.title,
      value: productFund.id,
      data: productFund,
    }));

    return itemsForVuetifySelect;
  }
}
